import * as React from 'react';
import { graph } from '../graph'
import { Storage } from '../storage'

/**
 * logoutQL
 * @return {[type]}      [description]
 */
function logoutQL({ token }: any) {
  return graph(`{ logout(token: "${token}") } `)
}


export class Logout extends React.Component {
  static props: any;
  static logout() {
    const sessions: any = Storage.get('me', [])
    const currentSession: any = Storage.get('meCurrent')

    if (!currentSession) {
      window.location.href = `/en/signin`
      return
    }

    const sessionsNew = []
    for (const session of sessions) {
      if (session.token !== currentSession.token) {
        sessionsNew.push(session)
      }
    }

    Storage.remove('meCurrent')
    if (sessionsNew.length === 0) {
      Storage.remove('me')
      Storage.remove('isLogged')
    } else {
      Storage.set('meCurrent', sessionsNew[0])
      Storage.set('me', sessionsNew)
    }
    logoutQL({ token: currentSession.token }).then(() => {
      const language = Storage.get('language')
      localStorage.clear() // v2
      Storage.set('language', language)
    })
  }
}



// WEBPACK FOOTER //
// ./src/utils/logout/index.tsx